




















































































































/* eslint-disable no-unused-vars */
import BaseForm from '@/views/BaseForm';
import { Component } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import { loginUserMdl } from '@/models/userMdl';
/* eslint-enable no-unused-vars */

@Component({
    name: 'login',
    head: {
        title: {
            inner: 'ログイン',
            separator: '-',
            complement: 'Battery-Surveillance',
        },
    },
})
export default class login extends BaseForm {
    // ログイン用
    private login_id: string = ''; // ログインID
    private login_password: string = ''; // パスワード
    private remember_me: boolean = false; // ログインIDを記憶
    private showPassword: boolean = false; // パスワード表示
    // パスワード再発行用
    private reset_login_id: string = ''; // ログインID
    private reset_mail_address: string = ''; // メールアドレス
    private tabnumber = 0; //タブ番号

    get refs(): any {
        return this.$refs;
    }

    created() {
        // storeの内容を削除
        this.$store.dispatch('user/initializeParamAc');
        this.$store.dispatch('common/initializeParamAc');
        // sessionStorageを削除
        sessionStorage.removeItem('buttery-surveillance');
        // cookieにアカウントが保存されている場合、初期表示する
        let cookie_data: any = this.$cookies.get('buttery-surveillance-cookie');
        if (cookie_data !== null) {
            this.login_id = cookie_data.login_id;
            this.remember_me = cookie_data.remember_me;
        }
    }
    mounted() {
        let outerThis: this = this;
        window.document.onkeydown = function(event) {
            if (event.key === 'Enter') {
                if (outerThis.tabnumber == 0) {
                    let focusEl = document.activeElement as HTMLCanvasElement;
                    if (focusEl.id != 'loginbtn' && focusEl.id != 'tab1' && focusEl.id != 'tab2') {
                        outerThis.onClickLogin();
                    }
                }
            }
        };
    }

    // ログイン処理
    private async onClickLogin() {
        if (this.refs.formlogin.validate() === false) {
            // 入力チェックで不備あり判定の為、後続処理は行わない
            return;
        }

        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            let params: any = {
                user_account: this.login_id,
                password: this.login_password,
            };
            const resp: AxiosResponse<any> = await this.$http.post('login.php', params);

            switch (resp.data.result) {
                case 'SUCCESS':
                    // UserStoreにデータを格納
                    await this.$store.dispatch(
                        'user/setParamAc',
                        new loginUserMdl(loginUserMdl.toJsonDataOnModel(resp.data.items))
                    );
                    // UserStoreにアクセストークンを格納
                    await this.$store.dispatch('user/setTokenAc', resp.data.items.token);
                    // ログインIDを記憶
                    if (this.remember_me) {
                        // cookieに保存
                        let cookie_param: any = {
                            login_id: this.login_id,
                            remember_me: this.remember_me,
                        };
                        this.$cookies.set('buttery-surveillance-cookie', cookie_param);
                    } else {
                        // ログインIDを記憶解除
                        this.$cookies.remove('buttery-surveillance-cookie');
                    }
                    // マップ画面へ遷移
                    this.$router.push({ path: '/pmap' }, () => {});
                    break;
                case 'VALIDATION_ERROR':
                    // バリデーションエラーメッセージをセット
                    this.validationErrors = resp.data.errors;
                    break;
                case 'AUTH_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'ログイン失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'ログイン失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }

    // パスワード再発行処理
    private async onClickReset() {
        if (this.refs.formreset.validate() === false) {
            // 入力チェックで不備あり判定の為、後続処理は行わない
            return;
        }

        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            let params: any = {
                user_account: this.reset_login_id,
                mail_address: this.reset_mail_address,
            };
            const resp: AxiosResponse<any> = await this.$http.post('password_reset.php', params);

            switch (resp.data.result) {
                case 'SUCCESS':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'success',
                        timeout: 5000,
                        message: 'パスワード再発行成功',
                        return_flg: false,
                    });
                    break;
                case 'VALIDATION_ERROR':
                    // バリデーションエラーメッセージをセット
                    this.validationErrors = resp.data.errors;
                    break;
                case 'SAVE_FAILED_ERROR':
                case 'DBCONNECTION_ERROR':
                case 'DATA_NOTFOUND_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'パスワード再発行失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'パスワード再発行失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }

    // タブ切り替え時
    private tabChange() {
        // バリデーションのリセット
        this.refs.formlogin.resetValidation();
        this.refs.formreset.resetValidation();
    }
}
